import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import DoneIcon from '@mui/icons-material/Done';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import TableCell from '@mui/material/TableCell';


import { IconButton, Switch, Tooltip } from '@mui/material';


const ProductsRow = ({ row, updateForm, onDelete, index, handleActive }) => {
  return (
    <>
      <TableCell component="th" align="center" scope="row" key={index}>
        {row.IdCampProduct}
      </TableCell>
      <TableCell align="center" key={index}>{row.Product}</TableCell>
      <TableCell align="center" key={index}>{row.Label}</TableCell>
      <TableCell align="center" style={{ maxWidth: '150px' }} key={index}>{row.CreateDate}</TableCell>

      <TableCell align="center" key={index}>
        <Tooltip title="Edit">
          <IconButton onClick={() => { updateForm(row) }}>
            <ModeEditOutlineOutlinedIcon />
          </IconButton>
        </Tooltip>

        <Tooltip title="Delete">
          <IconButton onClick={() => { onDelete(row.IdCampProduct) }}>
            <DeleteForeverOutlinedIcon />
          </IconButton>
        </Tooltip>
      </TableCell>
    </>
  );
}

export default ProductsRow;